<template>
  <div id="app">
    <!-- 全局组件banner -->
    <Banner />
    <!-- 路由模块展示 -->
    <router-view></router-view>
  </div>
</template>

<script>
import Banner from './components/global/Banner.vue'

export default {
  name: 'App',
  components: {
    Banner
  }
}
</script>

<style>
body {
  width: 100% !important;
}
#app {
  height: auto;
}
ol,
ul,
li {
  list-style: none;
}
/* div {
  margin: 0;
  padding: 0;
} */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
}
</style>
